const Cookies = require('js-cookie');

function init() {
    const container = document.querySelector('.global-newsletter');

    if (!container) {
        return false;
    }

    const closeContainer = document.querySelector('.global-newsletter__close');
    const cookieName = 'newsletterPopupClosed';
    const cookieDomain = location.hostname.replace('www', '').replace('cms', '');

    const closed = parseInt(Cookies.get(cookieName), 10) || 0;
    const source = (getUrlParameter('utm_source') || null) === 'wordfly';

    if (closed || source) {
        return false;
    }

    setTimeout(function() {
        container.classList.add('global-newsletter--visible');
    }, 2500);

    closeContainer.onclick = function() {
        container.classList.remove('global-newsletter--visible');

        Cookies.set(cookieName, 1, {
            domain: cookieDomain,
            path: '/',
            expires: 365
        });
    }
}

function getUrlParameter(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

module.exports = {
    init
}
